import { render, staticRenderFns } from "./modifyRangesModal.vue?vue&type=template&id=50c097b8&scoped=true&"
import script from "./modifyRangesModal.vue?vue&type=script&lang=js&"
export * from "./modifyRangesModal.vue?vue&type=script&lang=js&"
import style0 from "./modifyRangesModal.vue?vue&type=style&index=0&id=50c097b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c097b8",
  null
  
)

export default component.exports